import { Col, Flex } from "antd";

const HeaderList = ({ cols }: any) => {
  const data = [];

  return (
    <div className="flex items-center whitespace-nowrap">
      {cols.map((e: any, index: number) => (
        <Col
          key={index}
          className={`${
            index === 0 ? "px-3" : "" // Add px-3 for the first item
          } ${
            index === cols.length - 1 ? "px-3" : "" // Add px-3 for the last item
          } text-black mb-6 whitespace-nowrap max-lg:min-w-[150px] border-r-0 border-l-0 border-t-0 border-b-[1px] border-color-primary border-solid border-[1px] w-full py-3 text-center text-sm`}
        >
          {e}
        </Col>
      ))}
    </div>
  );
};

export default HeaderList;
